import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
const {getUrl} = Util;
import Smartdown from "@/assets/images/academy/smartdown.png";
import Liright from "@/assets/images/academy/liright.png";
import Smartbg from "@/assets/images/academy/smartbg.png";
import Baseinfo from "@/assets/images/academy/baseinfo.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Smart: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.smart, className)}>
      <div className={cx(styles.smarttop, className)}>
        <h2>Smart Contract</h2>
        <div>
          <a href={getUrl("/academy/learn-smart-contract")}>
            <p>View All</p>
            <img src={Smartdown} />
          </a>
        </div>
      </div>
      <div className={cx(styles.smartbottom, className)}>
        <img src={Smartbg} />
        <div className={cx(styles.smartbtmr, className)}>
          <ul>
            <li>
              <a href={getUrl("/academy/learn-smart-contract#smart0")}>
                {isMobile ? <span>.</span> : <div></div>}
                <h4>
                  <span>What is a Smart Contract? </span>
                  {isMobile ? <img src={Baseinfo} /> : <img src={Liright} />}
                </h4>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-smart-contract#smart1")}>
                {isMobile ? <span>.</span> : <div></div>}
                <h4>
                  <span>How do Smart Contracts Work?</span>
                  {isMobile ? <img src={Baseinfo} /> : <img src={Liright} />}
                </h4>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-smart-contract#smart2")}>
                {isMobile ? <span>.</span> : <div></div>}
                <h4>
                  <span>So how do we incorporate external factors into a Smart Contract? </span>
                  {isMobile ? <img src={Baseinfo} /> : <img src={Liright} />}
                </h4>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-smart-contract#smart3")}>
                {isMobile ? <span>.</span> : <div></div>}
                <h4>
                  <span>Who came up with the idea of a Smart Contract? </span>
                  {isMobile ? <img src={Baseinfo} /> : <img src={Liright} />}
                </h4>
              </a>
            </li>
            <li>
              <a href={getUrl("/academy/learn-smart-contract#smart4")}>
                {isMobile ? <span>.</span> : <div></div>}
                <h4>
                  <span>Are Smart Contracts safe? </span>
                  {isMobile ? <img src={Baseinfo} /> : <img src={Liright} />}
                </h4>
              </a>
            </li>
          </ul>
          {isMobile ? (
            <h4>
              Keen to get started using Smart Contracts?
              <br />
              <p>
                <span>Let's go to </span>
                <a href="/" target="_blank">
                  sigma.com
                </a>
              </p>
            </h4>
          ) : (
            <h4>
              Keen to get started using Smart Contracts? Let's go to
                <a href="/" target="_blank">
                  sigma.com
                </a>
            </h4>
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(Smart);
// export default Main;
